<div class="page-header"><h1 class="page-title">Roles and Permission</h1></div>

<table class="table">
	<thead>
		<tr>
			<th>&nbsp;</th>
			<th>&nbsp;</th>
			<th *ngFor="let appRole of appRoles">
				{{appRole.name}}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr class="table-dark">
			<td>Agent Management</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of agentPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td>Partner Management</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of partnerPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td>Subscriber File Upload</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of importPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td>Subscriber</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of subscriberPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>


		<tr class="table-dark">
			<td>Masking</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of maskingPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>


		<tr class="table-dark">
			<td>System</td>
			<td [colSpan]="appRoles.length+1">&nbsp;</td>
		</tr>
		<tr *ngFor="let permission of systemPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>
	</tbody>
</table>
<div class="row" *hasPermission="['PermissionEdit']">
	<div class="col">
		<button class="btn btn-primary float-end" (click)="doSubmit()">Save</button>
	</div>
</div>
